var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserSquare = function SvgUserSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.094 14.413c-.587.174-1.28.254-2.093.254H6c-.814 0-1.507-.08-2.094-.254.147-1.733 1.927-3.1 4.094-3.1 2.166 0 3.946 1.367 4.093 3.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10 1.333H6C2.668 1.333 1.335 2.667 1.335 6v4c0 2.52.76 3.9 2.573 4.413.147-1.733 1.927-3.1 4.094-3.1 2.166 0 3.946 1.367 4.093 3.1 1.813-.513 2.573-1.893 2.573-4.413V6c0-3.333-1.333-4.667-4.666-4.667M8 9.447a2.39 2.39 0 0 1 0-4.78 2.39 2.39 0 0 1 0 4.78"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.387 7.053A2.39 2.39 0 0 1 8 9.447a2.39 2.39 0 0 1 0-4.78 2.384 2.384 0 0 1 2.387 2.386"
  })));
};
export default SvgUserSquare;